import { Reducer } from 'redux';

import { ChainsFromConfig } from 'config/configType';

// Actions

// export const openHashSignatureInfoModal = ({
//   title,
//   signingHash,
// }: {
//   title?: string;
//   signingHash: string;
// }) => ({ type: 'OPEN_HASH_SIGNATURE_INFO_MODAL' as const, title, signingHash });

export const openTypedDataSignatureInfoModal = ({
  title,
}: // typedDataStringified,
{
  title?: string;
  // typedDataStringified: string;
}) => ({
  type: 'OPEN_TYPEDDATA_SIGNATURE_INFO_MODAL' as const,
  title,
  // typedDataStringified,
});

export const openTextSignatureInfoModal = ({
  title,
  signingText,
}: {
  title?: string;
  signingText: string;
}) => ({ type: 'OPEN_TEXT_SIGNATURE_INFO_MODAL' as const, title, signingText });

export const openTransactionSignatureModal = ({
  title,
  chain,
}: {
  title?: string;
  chain: ChainsFromConfig;
}) => ({ type: 'OPEN_TRANSACTION_SIGNATURE_MODAL' as const, title, chain });

export const closeSignatureInfoModal = () => ({
  type: 'CLOSE_SIGNATURE_INFO_MODAL' as const,
});

type SignatureModalAction = ReturnType<
  // | typeof openHashSignatureInfoModal
  | typeof openTypedDataSignatureInfoModal
  | typeof openTextSignatureInfoModal
  | typeof closeSignatureInfoModal
  | typeof openTransactionSignatureModal
>;

// Reducer

type SignatureModal = {
  title?: string;
  signingText?: string;
  signingHash?: string;
  signingTyped?: boolean;
  signingTransaction?: ChainsFromConfig;
};

const defaultState: SignatureModal = {
  title: undefined,
  signingText: undefined,
  signingHash: undefined,
  signingTyped: undefined,
  signingTransaction: undefined,
};

export const signatureModalReducer: Reducer<
  SignatureModal,
  SignatureModalAction
> = (state = defaultState, action): SignatureModal => {
  switch (action.type) {
    case 'OPEN_TEXT_SIGNATURE_INFO_MODAL':
      return {
        title: action.title,
        signingText: action.signingText,
      };
    // case 'OPEN_HASH_SIGNATURE_INFO_MODAL':
    //   return {
    //     title: action.title,
    //     signingHash: action.signingHash,
    //   };
    case 'OPEN_TYPEDDATA_SIGNATURE_INFO_MODAL':
      return {
        title: action.title,
        signingTyped: true, // action.typedDataStringified,
      };
    case 'OPEN_TRANSACTION_SIGNATURE_MODAL':
      return {
        title: action.title,
        signingTransaction: action.chain,
      };
    case 'CLOSE_SIGNATURE_INFO_MODAL':
      return defaultState;
    default:
      return state;
  }
};
